import script from "./AchievementInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./AchievementInfo.vue?vue&type=script&setup=true&lang=js"

import "./AchievementInfo.vue?vue&type=style&index=0&id=314e021c&lang=scss&scoped=true"

import exportComponent from "/PPPoker/kkpoker-anniversary/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-314e021c"]])

export default __exports__